import { PositionRange } from '../../types'
import { CutterAudio } from '../entities/CutterAudio'
import { AudioChunk } from '../entities/AudioChunk'

export function cutAudio(audio: CutterAudio, range: PositionRange): CutterAudio {
  const chunks = audio.chunks.flatMap((chunk) => chunk.cut(range)).filter((chunk) => chunk.length)

  return { ...audio, chunks, length: getLength(chunks) }
}

export function cropAudio(audio: CutterAudio, range: PositionRange): CutterAudio {
  // First cut from the end to not adjust cutting range due to chunks shift.
  const chunks = audio.chunks
    .flatMap((chunk) => chunk.cut([range[1], audio.length]))
    .flatMap((chunk) => chunk.cut([0, range[0]]))
    .filter((chunk) => chunk.length)

  return { ...audio, chunks, length: getLength(chunks) }
}

function getLength(chunks: AudioChunk[]): number {
  return chunks.reduce((max, chunk) => Math.round(Math.max(chunk.end, max)), 0)
}
